import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: t("f5networks.content_types.global_traffic"), value: "GTM" },
    { label: t("f5networks.content_types.local_traffic"), value: "LTM" },
    { label: t("f5networks.content_types.mail_logs"), value: "MAIL" },
    { label: t("f5networks.content_types.security"), value: "SECURITY" },
    { label: t("f5networks.content_types.traffic_manager_microkernel"), value: "TMM" },
    { label: t("f5networks.content_types.user_process"), value: "USER" },
    { label: t("f5networks.content_types.application_messages"), value: "MESSAGES" },
    { label: t("f5networks.content_types.audit"), value: "AUDIT" },
    { label: t("f5networks.content_types.daemon"), value: "DAEMON" },
    { label: t("f5networks.content_types.kernel"), value: "KERNEL" },
    { label: t("f5networks.content_types.webui"), value: "WEBUI" }
  ];
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const handleSubmit = () => {
    let error = false;
    formData.content_type.value = contentTypes;
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("f5networks.errors.polling_interval_invalid"),
        nice_message: t("f5networks.errors.polling_interval_min")
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("f5networks.fields.logs_types")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "content_type",
        id: "content_type",
        onChange: (selected) => setContentTypes(selected),
        options: availableContent,
        value: contentTypes
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("f5networks.fields.logs_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("f5networks.fields.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
